export enum ExternalLinks {
  TermsOfUse = 'https://ryddm.com/terms',
  PrivacyPolicy = 'https://ryddm.com/privacy-policy',
  FAQ = 'https://support.ryddm.com/support/home',
  Support = 'https://support.ryddm.com/support/home',
  Contacts = 'https://support.ryddm.com/support/home',
}
